<template>
  <div>
    <h3 class="header">{{title}}</h3>
    <h5 class="header">{{teacher}} ({{course}})</h5>
    <div class="title">
      <div style="font-size:12px;margin:10px;color:gray">{{desc}}</div>
      <van-cell-group style="display:flex;align-items:center">
        <br />
        <span style="color:red">*</span>
        <span class="margin">姓名:</span>
        <span>
          <van-field clearable v-model="question.username" placeholder="请输入真实姓名" />
        </span>
      </van-cell-group>
      <van-cell-group style="display:flex;align-items:center">
        <br />
        <span style="color:red">*</span>
        <span class="margin">部门:</span>
        <span>
          <van-field clearable v-model="question.dep" placeholder="请输入部门" />
        </span>
      </van-cell-group>
      <van-cell-group style="display:flex;align-items:center">
        <br />
        <span style="color:red">*</span>
        <span class="margin">岗位:</span>
        <span>
          <van-field clearable v-model="question.postion" placeholder="请输入岗位" />
        </span>
      </van-cell-group>
      <van-cell-group style="display:flex;align-items:center">
        <br />
        <span style="color:red">*</span>
        <span class="margin">联系方式:</span>
        <span>
          <van-field clearable v-model="question.mobile" placeholder="请输入手机号码" />
        </span>
      </van-cell-group>
      <div>
        <h6 style="margin:20px 0 0px 0;padding:0;">
          <span style="color:red">*</span>1.您对此次内容的总体评价
        </h6>
        <div style="display:flex;">
          <van-radio-group style="margin:0;padding:0;display:flex;" v-model="question.radio1">
            <van-radio class="radio" name="1">非常满意</van-radio>
            <van-radio class="radio" name="2">满意</van-radio>
            <van-radio class="radio" name="3">基本满意</van-radio>
            <van-radio class="radio" name="4">不满意</van-radio>
          </van-radio-group>
        </div>
      </div>
      <div>
        <h6 style="margin:20px 0 0px 0;padding:0;">
          <span style="color:red">*</span>2.您认为此次内容是否具有针对性(适合我的需求)
        </h6>
        <div style="display:flex;">
          <van-radio-group style="margin:0;padding:0;display:flex;" v-model="question.radio2">
            <van-radio class="radio" name="1">非常满意</van-radio>
            <van-radio class="radio" name="2">满意</van-radio>
            <van-radio class="radio" name="3">基本满意</van-radio>
            <van-radio class="radio" name="4">不满意</van-radio>
          </van-radio-group>
        </div>
      </div>
      <div>
        <h6 style="margin:20px 0 0px 0;padding:0;">
          <span style="color:red">*</span>3.您认为此次培训内容对您的工作实践是否有帮助
        </h6>
        <div style="display:flex;">
          <van-radio-group style="margin:0;padding:0;display:flex;" v-model="question.radio3">
            <van-radio class="radio" name="1">非常满意</van-radio>
            <van-radio class="radio" name="2">满意</van-radio>
            <van-radio class="radio" name="3">基本满意</van-radio>
            <van-radio class="radio" name="4">不满意</van-radio>
          </van-radio-group>
        </div>
      </div>
      <div>
        <h6 style="margin:20px 0 0px 0;padding:0;">
          <span style="color:red">*</span>4.您认为此次培训内容是否达到您的预期
        </h6>
        <div style="display:flex;">
          <van-radio-group style="margin:0;padding:0;display:flex;" v-model="question.radio4">
            <van-radio class="radio" name="1">非常满意</van-radio>
            <van-radio class="radio" name="2">满意</van-radio>
            <van-radio class="radio" name="3">基本满意</van-radio>
            <van-radio class="radio" name="4">不满意</van-radio>
          </van-radio-group>
        </div>
      </div>
      <div>
        <h6 style="margin:20px 0 0px 0;padding:0;">
          <span style="color:red">*</span>5.您认为此次培训的讲师总体评价
        </h6>
        <div style="display:flex;">
          <van-radio-group style="margin:0;padding:0;display:flex;" v-model="question.radio5">
            <van-radio class="radio" name="1">非常满意</van-radio>
            <van-radio class="radio" name="2">满意</van-radio>
            <van-radio class="radio" name="3">基本满意</van-radio>
            <van-radio class="radio" name="4">不满意</van-radio>
          </van-radio-group>
        </div>
      </div>
      <div>
        <h6 style="margin:20px 0 0px 0;padding:0;">
          <span style="color:red">*</span>6.您认为此次授课老师表达与解说能力如何
        </h6>
        <div style="display:flex;">
          <van-radio-group style="margin:0;padding:0;display:flex;" v-model="question.radio6">
            <van-radio class="radio" name="1">非常满意</van-radio>
            <van-radio class="radio" name="2">满意</van-radio>
            <van-radio class="radio" name="3">基本满意</van-radio>
            <van-radio class="radio" name="4">不满意</van-radio>
          </van-radio-group>
        </div>
      </div>
      <div>
        <h6 style="margin:20px 0 0px 0;padding:0;">
          <span style="color:red">*</span>7.您认为讲师的专业程度和知识丰富程度如何
        </h6>
        <div style="display:flex;">
          <van-radio-group style="margin:0;padding:0;display:flex;" v-model="question.radio7">
            <van-radio class="radio" name="1">非常满意</van-radio>
            <van-radio class="radio" name="2">满意</van-radio>
            <van-radio class="radio" name="3">基本满意</van-radio>
            <van-radio class="radio" name="4">不满意</van-radio>
          </van-radio-group>
        </div>
      </div>
      <div>
        <h6 style="margin:20px 0 0px 0;padding:0;">
          <span style="color:red">*</span>8.您认为此次授课老师对于课程主题的把握和逻辑性如何
        </h6>
        <div style="display:flex;">
          <van-radio-group style="margin:0;padding:0;display:flex;" v-model="question.radio8">
            <van-radio class="radio" name="1">非常满意</van-radio>
            <van-radio class="radio" name="2">满意</van-radio>
            <van-radio class="radio" name="3">基本满意</van-radio>
            <van-radio class="radio" name="4">不满意</van-radio>
          </van-radio-group>
        </div>
      </div>
      <div>
        <h6 style="margin:20px 0 0px 0;padding:0;">
          <span style="color:red">*</span>9.您认为此次授课老师在授课中实际案例的运用如何
        </h6>
        <div style="display:flex;">
          <van-radio-group style="margin:0;padding:0;display:flex;" v-model="question.radio9">
            <van-radio class="radio" name="1">非常满意</van-radio>
            <van-radio class="radio" name="2">满意</van-radio>
            <van-radio class="radio" name="3">基本满意</van-radio>
            <van-radio class="radio" name="4">不满意</van-radio>
          </van-radio-group>
        </div>
      </div>
      <div>
        <h6 style="margin:20px 0 0px 0;padding:0;">
          <span style="color:red">*</span>10.您认为此次授课老师对于课堂氛围的把握调节与控制如何
        </h6>
        <div style="display:flex;">
          <van-radio-group style="margin:0;padding:0;display:flex;" v-model="question.radio10">
            <van-radio class="radio" name="1">非常满意</van-radio>
            <van-radio class="radio" name="2">满意</van-radio>
            <van-radio class="radio" name="3">基本满意</van-radio>
            <van-radio class="radio" name="4">不满意</van-radio>
          </van-radio-group>
        </div>
      </div>
      <div>
        <h6 style="margin:20px 0 0px 0;padding:0;">
          <span style="color:red">*</span>11.您对此次培训教学组织形式丶课堂纪律等培训软环境评价如何
        </h6>
        <div style="display:flex;">
          <van-radio-group style="margin:0;padding:0;display:flex;" v-model="question.radio11">
            <van-radio class="radio" name="1">非常满意</van-radio>
            <van-radio class="radio" name="2">满意</van-radio>
            <van-radio class="radio" name="3">基本满意</van-radio>
            <van-radio class="radio" name="4">不满意</van-radio>
          </van-radio-group>
        </div>
      </div>
      <div>
        <h6 style="margin:20px 0 0px 0;padding:0;">
          <span style="color:red">*</span>12.您对此次培训时间安排评价如何
        </h6>
        <div style="display:flex;">
          <van-radio-group style="margin:0;padding:0;display:flex;" v-model="question.radio12">
            <van-radio class="radio" name="1">非常满意</van-radio>
            <van-radio class="radio" name="2">满意</van-radio>
            <van-radio class="radio" name="3">基本满意</van-radio>
            <van-radio class="radio" name="4">不满意</van-radio>
          </van-radio-group>
        </div>
      </div>
      <!-- <div>
        <h6 style="margin:20px 0 0px 0;padding:0;">2.您认为此次内容是否具有针对性(适合我的需求)</h6>
        <div style="display:flex;">
          <van-radio-group style="margin:0;padding:0;" v-model="question.multi">
            <div v-for="(item,index) in ite" :key="index">
              <van-radio class="radio" :name="index">{{item}}</van-radio>
            </div>
          </van-radio-group>
        </div>
      </div>-->
      <div>
        <h6>13.此次培训内容中,您认为对您最有启发的三个方面在哪里</h6>
        <van-cell-group>
          <van-field
            v-model="question.text1"
            style="border:1px solid #000000"
            type="textarea"
            rows="2"
            autosize
          />
        </van-cell-group>
      </div>
      <div>
        <h6>14.在上述三个方面中,您会马上去实施的是哪些方面</h6>
        <van-cell-group>
          <van-field
            v-model="question.text2"
            style="border:1px solid #000000"
            type="textarea"
            rows="2"
            autosize
          />
        </van-cell-group>
      </div>
      <div>
        <h6>15.如果有可能,您期望未来再展开哪些内容的培训</h6>
        <van-cell-group>
          <van-field
            v-model="question.text3"
            style="border:1px solid #000000"
            type="textarea"
            rows="2"
            autosize
          />
        </van-cell-group>
      </div>
      <div>
        <h6>16.为了能更好的提供优质培训服务,您对此次培训有什么评价和建议</h6>
        <van-cell-group>
          <van-field
            v-model="question.text4"
            style="border:1px solid #000000"
            type="textarea"
            rows="2"
            autosize
          />
        </van-cell-group>
      </div>
      <br />

      <div style="display:flex;justify-content: center;">
        <van-button type="primary" class="submit" @click="submitAnswer">提交答案</van-button>
      </div>
      <div class="footer">
        <br />
        {{ad}}
        <br />@锐道咨询
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "",
      questions: "",
      desc: "",
      ad: "",
      question: {
        id: "",
        radio1: "1",
        radio2: "1",
        radio3: "1",
        radio4: "1",
        radio5: "1",
        radio6: "1",
        radio7: "1",
        radio8: "1",
        radio9: "1",
        radio10: "1",
        radio11: "1",
        radio12: "1",
        username: "",
        branch: "",
        dep: "",
        mobile: "",
        text4: "",
        text1: "",
        text2: "",
        text3: ""
      },

      course: "",
      teacher: ""
    };
  },
  methods: {
    submitAnswer() {
      if (
        this.question.username == "" ||
        this.question.position == "" ||
        this.question.dep == "" ||
        this.question.mobile == ""
      ) {
        this.$toast({
          message: "请填写完整信息",
          type: "waring"
        });
      } else if (
        this.question.radio1 == "" ||
        this.question.radio2 == "" ||
        this.question.radio3 == "" ||
        this.question.radio4 == "" ||
        this.question.radio5 == "" ||
        this.question.radio6 == "" ||
        this.question.radio7 == "" ||
        this.question.radio8 == "" ||
        this.question.radio9 == "" ||
        this.question.radio10 == "" ||
        this.question.radio11 == "" ||
        this.question.radio12 == ""
      ) {
        this.$toast({
          message: "请填写完整信息",
          type: "waring"
        });
      } else {
        this.$http
          .post("/oa/wxdianping/teacher_wenjuan", this.question)
          .then(res => {
            if (res.data.code == 200) {
              this.$toast({
                message: res.data.message,
                type: "success",
                duration: 10000
              });
              this.question = {};
              this.multi = [];
            } else {
              this.$toast({
                message: res.data.message,
                type: "waring",
                duration: 10000
              });
            }
          });
      }
    }
  },
  created() {
    console.log(this.$route.query.id);
    if (this.$route.query.id) {
      this.question.id = this.$route.query.id;
      this.$http
        .post("/oa/wxdianping/teacher_index?id=" + this.question.id)
        .then(res => {
          this.course = res.data.data.course;

          this.title = res.data.data.title;
          this.teacher = res.data.data.teacher;
          this.$route.query.id = res.data.data.id;
        });
      // this.$http.get("/oa/wxzhuzi/multi_wenjuan?id=" + id).then(res => {

      // });
    } else {
      const id = 2;
      this.$http.post("/oa/wxdianping/teacher_index?id=" + id).then(res => {
        this.course = res.data.data.course;

        this.title = res.data.data.title;
        this.teacher = res.data.data.teacher;
        this.desc = res.data.data.desc;
        this.$route.query.id = res.data.data.id;
      });
      // this.$http.get("/oa/wxzhuzi/multi_wenjuan?id=" + id).then(res => {

      // });
    }
  }
};
</script>

<style scoped>
.title {
  width: 90%;
  margin: 0 0 0 20px;
  font-size: 12px;
}
.header {
  width: 100%;
  text-align: center;
  margin: 10px 0 0 0;
}
.radio {
  margin: 20px 0 0 0;
}
.submit {
  border-radius: 10px;

  width: 100px;
  height: 40px;
}
.margin {
  margin: 10px;
}
.footer {
  text-align: center;
  color: gray;
  font-size: 14px;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/user/question.vue